import * as store from '../stores/ReduxStore'
import ReactGA from "react-ga4";
import i18next from 'i18next';
import {
    BETSLIP_TABS,
    getOddsFormatById,
    Mode,
    MARKET_TABS,
    SelectionType,
    SPORT_TABS,
    ALL_SPORTS
} from "./Foundation";
import Constants from "./Constants";
import {get, isEmpty, uniq, split} from "lodash";
import cookie from "react-cookies";
import BetslipCommon from "./BetslipCommon";
import BetslipHelper from "../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper";
import CommonUtil from "./CommonUtil";

export const GA_EVENT = {
    LOGIN: 'Login',
    MATCH_UP_PAGE_VIEW: 'Matchup Page View',
    SPORT_VIEW: 'Sport View',
    LEAGUES_PAGE_VIEW: 'League Page View',
    PAGE_VIEW: 'Page View Event',
    BET_SLIP: 'Bet Slip',
    BET_SLIP_LIVE_ACCEPTANCE: 'Bet Slip Live Acceptance'
}

const BETSLIP = {
    SINGLE: 'Singles',
    PARLAY: 'Parlays',
    TEASERS: 'Teasers'
}

const isDisabledGA = () => {
    return !window.env || !window.env.isEnableGaGtm;
}

const getState = () => {
    return store.default.getState();
}

const getCategory = (res) => {
    const {allComponents} = getState().LayoutTemplateSlice.templateData;
    const pathName = window.location.pathname;
    const navComponent = allComponents.find(item => item.componentName === 'NavigationComponent');
    if (!isEmpty(navComponent) && !isEmpty(navComponent.initialData)) {
        const flatData = navComponent.initialData.menus.compactView.reduce((arr, item) => {
            return [...arr, item, ...(isEmpty(item.submenus) ? [] : item.submenus)]
        }, []);
        return get(flatData.find(item => pathName.includes(item.link) || res.id === item.id), 'name', '');
    }
    return '';
}

const getSiteSection = (res) => {
    const {selectedMarketTab, selectedSportId, selectedSportTab} = getState().SidebarSelectedDataSlice;
    const {mode} = res;
    const { marketTabs:sportMarketTabs, esportMarketTabs } = getState().SidebarHandlerSlice;
    const currentSelectedMarketTab = selectedMarketTab;
    const marketTabs = selectedSportId !== Constants.ESPORT_ID && selectedSportTab !== SPORT_TABS.ESPORTS ? sportMarketTabs : esportMarketTabs;
    if(mode && Mode.SEARCH === mode) {
        return "";
    }
    return get(marketTabs.find((item) => item.tabId === currentSelectedMarketTab), 'label', "");
}

const getTeaserBetType = (selectionType) => {
    if ([SelectionType.HOME, SelectionType.AWAY].includes(selectionType)) {
        return 'Handicap';
    }
    if ([SelectionType.OVER, SelectionType.UNDER].includes(selectionType)) {
        return `Over/Under`;
    }
    return '';
}


const getDataBetSlipTab = (selectedBetslipTab) => {
    const {oddsFormat} = getState().SportsSlice.options;
    let bets = [];
    let lineStakes = '';
    let lineToWins = '';
    let totalStake = '';
    let potentialWinnings = '';
    switch (selectedBetslipTab) {
        case BETSLIP_TABS.SINGLE:
            const {
                singleBets,
                totalStake: totalStakeSlice,
                potentialWinnings: potentialWinningsSlice,
                stakeInputs: stakeInputsSlice
            } = getState().BetslipSlice;
            bets = singleBets;
            totalStake = totalStakeSlice;
            potentialWinnings = potentialWinningsSlice;
            lineStakes = bets
                .map(item => stakeInputsSlice[item.oddsId] ? BetslipCommon.convertStakeToNumber(stakeInputsSlice[item.oddsId].riskVal).toDollar(2, true) : "")
                .join("|");
            lineToWins = bets
                .map(item => stakeInputsSlice[item.oddsId] ? BetslipCommon.convertStakeToNumber(stakeInputsSlice[item.oddsId].winVal).toDollar(2, true) : "")
                .join("|");
            break;
        case BETSLIP_TABS.PARLAY:
            const {
                parlayBets,
                parlayStake,
                selectedRROs
            } = getState().ParlayBetslipSlice;
            const winRiskInfo = BetslipHelper.getParlayWinRiskInfo(parlayStake, parlayBets.roundRobinOptions, selectedRROs, oddsFormat);
            bets = parlayBets.legs;
            totalStake = winRiskInfo.totalStake;
            potentialWinnings = winRiskInfo.toWin;
            lineStakes = BetslipCommon.convertStakeToNumber(parlayStake).toDollar(2, true);
            break;
        case BETSLIP_TABS.TEASERS:
            const {
                teaserBets,
                teaserWin,
                teaserRisk,
            } = getState().TeaserBetslipSlice;
            bets = teaserBets.legs;
            totalStake = teaserRisk;
            potentialWinnings = teaserWin;
            lineStakes = BetslipCommon.convertStakeToNumber(teaserRisk).toDollar(2, true);
            lineToWins = BetslipCommon.convertStakeToNumber(teaserWin).toDollar(2, true);
            break;
        default:
            break;
    }
    return {bets, totalStake, potentialWinnings, lineStakes, lineToWins}
}

const getDataBetSlipLive = (res) => {
    const {tab, data} = res;
    let statusBet = '';
    let stakeBet = '';
    let winBet = '';
    let marketBet = '';
    let errorCodeBet = '';
    switch (tab) {
        case BETSLIP_TABS.SINGLE:
            statusBet = data.status === Constants.BET_STATUS.ACCEPTED ? 'Accepted' : 'Rejected';
            winBet = data.win
            stakeBet = data.risk
            marketBet = data.betTypeDisp;
            errorCodeBet = data.errorCode;
            break;
        case BETSLIP_TABS.PARLAY:
            const {legs, status, acceptedBets, errorCode} = getState().ParlayBetslipSlice.parlayBetsSucessRes;
            statusBet = status === Constants.BET_STATUS.ACCEPTED ? 'Accepted' : 'Rejected';
            winBet = acceptedBets.reduce((total, item) => total + item.win, 0);
            stakeBet = acceptedBets.reduce((total, item) => total + item.risk, 0);
            marketBet = legs.map(item => item.betTypeDisp).join("|");
            errorCodeBet = errorCode;
            break;
        case BETSLIP_TABS.TEASERS:
            const {
                legs: legsTeaser,
                status: statusTeaser,
                riskAmount,
                winAmount,
                errorCode: errorCodeTeaser
            } = getState().TeaserBetslipSlice.teaserBetSucessRes;
            statusBet = ['OK', Constants.BET_STATUS.ACCEPTED].includes(statusTeaser) ? 'Accepted' : 'Rejected';
            winBet = winAmount;
            stakeBet = riskAmount;
            marketBet = legsTeaser.map(item => getTeaserBetType(item.selectionType)).join("|");
            errorCodeBet = errorCodeTeaser;
            break;
        default:
            break;
    }
    return {statusBet, marketBet, stakeBet, winBet, errorCodeBet};
}

export const GA4Common = {
    sendEventGA: (eventName, res) => {
        if (isDisabledGA()) return;
        let params = {};
        switch (eventName) {
            case GA_EVENT.LOGIN:
                params = GA4CommonEvent.eventLogin({...res});
                break;
            case GA_EVENT.MATCH_UP_PAGE_VIEW:
                params = GA4CommonEvent.eventMatchUpPageView({...res});
                break;
            case GA_EVENT.SPORT_VIEW:
                params = GA4CommonEvent.eventSportView({...res});
                break;
            case GA_EVENT.LEAGUES_PAGE_VIEW:
                params = GA4CommonEvent.eventLeaguesPageAccess({...res});
                break;
            case GA_EVENT.PAGE_VIEW:
                params = GA4CommonEvent.eventPageViewAccess({...res});
                break;
            case GA_EVENT.BET_SLIP:
                params = GA4CommonEvent.eventBetSlipSubmission({...res});
                break;
            case GA_EVENT.BET_SLIP_LIVE_ACCEPTANCE:
                params = GA4CommonEvent.eventBetSlipSubmissionLive({...res});
                break;
            default:
                break;
        }
        ReactGA.event(eventName, params);
    }
}

const GA4CommonEvent = {
    eventLogin: (res) => {
        const {user} = getState().AccountsSlice;
        return {
            login_step: res.auth ? 'Submitted' : 'Failed',
            user_id: res.loginId || '',
            site_version: 'Compact',
            language: user.locale,
            ...(!res.auth && res.message ? {login_error_message: res.message} : {}),
            login_with_email: res.loginId.includes('@') ? 'TRUE' : 'FALSE'
        }
    },
    eventMatchUpPageView: (res) => {
        const {sportId} = getState().SportsSlice.options;
        const {selectedMarketTab} = getState().SidebarSelectedDataSlice;
        return {
            sport: ALL_SPORTS[sportId],
            is_live: selectedMarketTab === MARKET_TABS.LIVE
        }
    },
    eventSportView: (res) => {
        const {sportId} = getState().SportsSlice.options;
        return {
            sport: ALL_SPORTS[sportId],
        }
    },
    eventLeaguesPageAccess: () => {
        const {options, search} = getState().SportsSlice;
        const {sportId, mode} = options;
        const {selectedLeagues, leagues} = getState().SelectLeaguesSlice;
        const isSearchPage = Mode.SEARCH === mode;
        const leagueMap = (leagues || []).reduce((obj, item) => ({
            ...obj, [item.leagueId]: item.leagueName
        }), {});
        return {
            sport: isSearchPage && search.sportId ? ALL_SPORTS[search.sportId] : ALL_SPORTS[sportId],
            league: isSearchPage ? (search.searchLeagueId ? search.searchText : "") : (selectedLeagues || []).map(item => leagueMap[item]).join() || 'All Leagues'
        }
    },
    eventPageViewAccess: (res) => {
        const {user} = getState().AccountsSlice;
        const {oddsFormat, mode} = getState().SportsSlice.options;
        const isMultipleOdds = mode === Mode.PARLAY || mode === Mode.PARLAY_MARKET || mode === Mode.TEASER || mode === Mode.TEASER_MARKET;
        const currentPageContainer = getState().LayoutTemplateSlice.currentPageContainer;
        const isSportView = currentPageContainer === "sportPageContainer";
        return {
            site_version: 'Compact',
            user_id: user.loginId || "Guest",
            language: CommonUtil.getCurrentLocaleCode(),
            currency: user.loginId ? user.currency : '',
            category: getCategory({...res}),
            odds_format: isSportView ? getOddsFormatById(oddsFormat) : '',
            odds_type: isSportView ? (isMultipleOdds ? "Multiple" : "Single") : '',
            error_message: (!res || isEmpty(res.errorMessage)) ? '' : res.errorMessage,
            domain: window.location.host,
            brand: 'Pinnacle East',
            site_section: isSportView ? getSiteSection({...res, mode}) : getCategory({...res}),
            affiliate_code: cookie.load("afrc") || ''
        }
    },
    eventBetSlipSubmission: (res) => {
        const {user} = getState().AccountsSlice;
        const {oddsFormat, mode} = getState().SportsSlice.options;
        const {selectedBetslipTab, isReuseSelection} = getState().BetslipSlice;
        const {bets, totalStake, potentialWinnings, lineStakes, lineToWins} = getDataBetSlipTab(selectedBetslipTab);
        const isMultipleOdds = selectedBetslipTab === BETSLIP_TABS.PARLAY || selectedBetslipTab === BETSLIP_TABS.TEASERS;
        const isOutright = mode === Mode.OUTRIGHT || mode === Mode.OUTRIGHT_MARKET;
        const sports = uniq(bets.map(item => item.sport || item.sportName)).join();
        const markets = bets.map(item => item.betTypeDisp || getTeaserBetType(item.selectionType)).join("|");
        const betsLive = bets.map(item => item.inplay ? 'Live' : 'Not Live').join("|");
        const descriptions = uniq(bets.map(item => isOutright ? `${item.eventName} ${item.parentEventName || ''}` : `${item.homeTeam} vs ${item.awayTeam}`)).join();
        return {
            site_version: 'Compact',
            user_id: user.loginId || "Guest",
            language: user.locale,
            currency: user.loginId ? user.currency : '',
            odds_format: getOddsFormatById(oddsFormat),
            odds_type: isMultipleOdds ? 'Multiple' : 'Single',
            betslip_event_live: betsLive,
            betslip_event_sport: sports,
            betslip_event_description: descriptions,
            betslip_event_market: markets,
            betslip_type: BETSLIP[selectedBetslipTab],
            betslip_line_stake: lineStakes,
            betslip_line_to_win: lineToWins,
            betslip_total_stake: BetslipCommon.convertStakeToNumber(totalStake).toDollar(2, true),
            betslip_total_to_win: BetslipCommon.convertStakeToNumber(potentialWinnings).toDollar(2, true),
            betslip_deposit_current_amount: res ? res.currentBalance || '' : '',
            betslip_lines_count: bets.length,
            betslip_error_message: split(get(res, "errorCode", ""), ',').map((errorMsg) => i18next.t("errors:" + errorMsg)).join(),
            betslip_reuse_selection: isReuseSelection ? 'Yes' : 'No',
        }
    },
    eventBetSlipSubmissionLive: (res) => {
        const {user} = getState().AccountsSlice;
        const {oddsFormat} = getState().SportsSlice.options;
        const selectedBetslipTab = getState().BetslipSlice.selectedBetslipTab;
        const {statusBet, marketBet, stakeBet, winBet, errorCodeBet} = getDataBetSlipLive(res);
        const isMultipleOdds = selectedBetslipTab === BETSLIP_TABS.PARLAY || selectedBetslipTab === BETSLIP_TABS.TEASERS;
        return {
            site_version: 'Compact',
            user_id: user.loginId || "Guest",
            language: user.locale,
            currency: user.loginId ? user.currency : '',
            odds_format: getOddsFormatById(oddsFormat),
            odds_type: isMultipleOdds ? 'Multiple' : 'Single',
            betslip_live_acceptance_status: statusBet,
            betslip_event_market: marketBet,
            betslip_line_stake: stakeBet ? BetslipCommon.convertStakeToNumber(stakeBet).toDollar(2, true) : stakeBet,
            betslip_line_to_win: winBet ? BetslipCommon.convertStakeToNumber(winBet).toDollar(2, true) : winBet,
            betslip_error_message: i18next.t("errors:" + (errorCodeBet || ""))
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/GA4Common.js